import { Box } from '@chakra-ui/react'
import React from 'react'

import { ConnectMetaMask } from '@/components/ConnectMetaMask'
import { Spinner } from '@/components/Spinner'
import { WrongChainIdWarning } from '@/components/WrongChainIdWarning'
import { MetaMaskState } from '@/hooks/useMetaMask'
import { OpenSeaState } from '@/hooks/useOpenSea'
import { CHAIN_ID } from '@/lib/constants'

type Props = {
  metamask: MetaMaskState
  opensea: OpenSeaState
  children: React.ReactNode
}

export const RequireWalletAccess = ({ metamask, opensea, children }: Props) => {
  const { isLoading, account, currentChainId, isMetaMaskInstalled, connect, onboarding } = metamask
  const { seaport } = opensea

  const connectWallet = async () => {
    if (isMetaMaskInstalled()) {
      try {
        await connect()
      } catch (err) {
        console.error(err.message)
        alert('Please allow access to MetaMask')
      }
      return
    }
    onboarding().startOnboarding()
  }

  return (
    <>
      {isLoading ? (
        <Box mt="8" textAlign="center">
          <Spinner />
        </Box>
      ) : (
        <>
          {account ? (
            <>
              {currentChainId !== CHAIN_ID ? (
                <WrongChainIdWarning correctChainId={CHAIN_ID} />
              ) : (
                <>
                  {seaport ? (
                    <>{children}</>
                  ) : (
                    <Box mt="8" textAlign="center">
                      <Spinner />
                    </Box>
                  )}
                </>
              )}
            </>
          ) : (
            <ConnectMetaMask onClick={connectWallet} />
          )}
        </>
      )}
    </>
  )
}
